import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";

import ReferralDialogNavigation from "features/Home/ReferralDialog/navigation";
import { REFERRAL_CREDIT } from "utils/influencer";
import { trackEvent } from "utils/tracking";

const SpecialAnnouncement = () => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [navigationReferDialog, setNavigationReferDialog] = useState(false);

  const handleStartReferring = () => {
    trackEvent("Referral Promo Button Clicked");
    setNavigationReferDialog(true);
  };
  return (
    <Grid
      container
      alignItems="center"
      sx={{ borderRadius: 2, boxShadow: 3, p: 3, mb: 3, mt: -3 }}
      item
      xs={12}
    >
      <Grid item xs={12} md={7} lg={8} container alignItems="center">
        <Typography component="div">
          <Box sx={{ fontSize: 15 }}>
            📢 <strong>July Promo:</strong> Get 4x Bento credits for any new
            referral from July 1-31. <br />
          </Box>
          Give ${REFERRAL_CREDIT} to a new user. Get ${REFERRAL_CREDIT} when
          they subscribed - enough for a month of Pro.
        </Typography>
      </Grid>

      <Grid
        item
        xs
        md
        lg
        container
        justifyContent={isMobileScreen ? "flex-start" : "flex-end"}
        sx={{ pr: 2, mt: { xs: 2, md: 0 } }}
      >
        <Button
          sx={{ backgroundColor: "info.main" }}
          variant="contained"
          disableElevation
          onClick={handleStartReferring}
        >
          Start Referring
        </Button>
      </Grid>
      <ReferralDialogNavigation
        open={navigationReferDialog}
        close={() => setNavigationReferDialog(false)}
        source="Referral Promo Button Clicked"
      />
    </Grid>
  );
};

export default SpecialAnnouncement;
